 
<template>
<div id="select-query-builder-modal" tabindex="-1" aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative p-4 w-full   max-w-2xl  ">
        <!-- Modal content -->
        <div class="relative bg-white rounded-lg shadow ">
            <!-- Modal header -->
            <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t ">
                <h3 class="text-lg font-semibold text-gray-900 ">
                    Connect wallet
                </h3>
                <button type="button" @click="onClose"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center "
                    data-modal-toggle="crypto-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <!-- Modal body -->
            <div class="p-4 md:p-5 h-full  overflow-none">
            
                <p class="text-sm font-normal text-gray-500 ">Connect with one of our available wallet
                    providers or create a new one.</p>
                    <div class="p-4 md:p-5     h-96 overflow-y-auto">
                    <QueryBuilder :values="values" :attributes="attributes" class="max-w-4xl" @update-value="onUpdateValue" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>


<script>
  import QueryBuilder from "@/components/QueryBuilder.vue";

    export default {
        name: "SelectQueryBuilderModal",
        props: {
            attributes : Array,
            values: Object
        },
        components: {
          QueryBuilder  
        },
        methods:{
            onClose() {
                this.$emit("close", {})
            },
            onConfirm() {
                this.$emit("confirm", {})
            },
            onUpdateValue()
            {

            }
        }
    }
</script>